<template>
    <div class="accept-review">
        <p class="title">Changes Approved</p>
        <p class="desc">We look forward to your gig</p>
        <button @click="btnFns.closeModal" class="close-modal-btn">Close</button>
    </div>
</template>
<script>
    import reviewSetCmpntAndProps from '@/mixins/review-set'
    export default {
        name: 'AcceptReview',
        mixins: [reviewSetCmpntAndProps]
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../../sass/_variables.scss';
    .accept-review {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 8px;

        .title {
            color: #dedede;
            font-family: 'Instrument Sans';
            font-size: 32px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            letter-spacing: -0.64px;
            max-width: 554px;
            width: 100%;
            text-wrap: nowrap;
        }
        .desc {
            color: #acacac;
            font-family: 'Instrument Sans';
            font-size: 16px;
            font-style: normal;
            font-weight: 550;
            line-height: 125%;
        }
        .close-modal-btn {
            margin-top: 52px;
            width: 100%;
            display: flex;
            padding: 12px 32px;
            justify-content: center;
            align-items: center;
            border-radius: 120px;
            font-family: 'Instrument Sans';
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            line-height: 133%;
            background: #cdeb09;
            color: #000;
        }
    }
</style>
